import React, { lazy } from "react";
import { withLazyRoute } from "@/components/loading/LazyRouteWrapper";
import {
  Home as HomeIcon,
  School as SchoolIcon,
  MenuBook as MenuBookIcon,
  Assignment as AssignmentIcon,
  People as CommunityIcon,
  AccountCircle as ProfileIcon,
  ViewKanban as ViewKanbanIcon,
  VolunteerActivism as VolunteerActivismIcon,
  CreditCard as CreditCardIcon,
} from "@mui/icons-material";
import { Navigation } from "types/navigation";
// import { FreeloHome } from "@/views/Shared/FreeloHome";
// import { FreeloBoard } from "@/views/Shared/FreeloBoard";
import { Navigate } from "react-router-dom";

const FreeloHome = withLazyRoute(
  lazy(() =>
    import("views/Shared/FreeloHome").then((m) => ({ default: m.FreeloHome }))
  ),
  "Loading freelo..."
);

const FreeloBoard = withLazyRoute(
  lazy(() =>
    import("views/Shared/FreeloBoard").then((m) => ({ default: m.default }))
  ),
  "Loading freelo board..."
);

const StudentHome = withLazyRoute(
  lazy(() => import("@/views/Dashboards/Student")),
  "Loading student home..."
);
const StudentMentorship = withLazyRoute(
  lazy(() => import("views/Student/StudentMentorship/StudentMentorship")),
  "Loading mentorship..."
);
const StudentManageSubscription = withLazyRoute(
  lazy(() =>
    import("views/Student/ManageSubscription/StudentManageSubscription").then(
      (m) => ({ default: m.StudentManageSubscription })
    )
  ),
  "Loading subscription management..."
);

export const studentPages: Navigation = [
  {
    kind: "page",
    title: "Home",
    segment: "student",
    icon: <HomeIcon />,
    component: <StudentHome />,
  },
  {
    kind: "page",
    title: "Mentorship",
    segment: "student/mentorship",
    icon: <VolunteerActivismIcon />,
    component: <StudentMentorship />,
  },
  {
    kind: "page",
    title: "Freelo",
    segment: "freelo",
    icon: <ViewKanbanIcon />,
    component: <FreeloHome />,
    slugBabyPattern: ":boardId",
    slugBabyComponent: <FreeloBoard />,
  },
];
